import(/* webpackMode: "eager", webpackExports: ["SignUpForm"] */ "/tmp/seed/source/app/sign-up/(components)/SignUpForm.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/seed/source/app/sign-up/solo/page.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["Center"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Center/Center.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Image/Image.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/components/Stack/Stack.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Box"] */ "/tmp/seed/source/node_modules/@mantine/core/esm/core/Box/Box.mjs");
